import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  class: "modal-body",
  style: {"min-height":"300px"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "lead" }
const _hoisted_10 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_13 = {
  class: "form-inline my-2 my-lg-0 ml-auto",
  role: "search"
}
const _hoisted_14 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = {
  class: "btn btn-sm btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_17 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "table" }
const _hoisted_20 = { class: "fg-color-gray mb-0 mt-1" }
const _hoisted_21 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_22 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_23 = { style: {"width":"80px"} }
const _hoisted_24 = ["onClick", "disabled"]
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = {
  class: "btn btn-outline-secondary",
  target: "_blank"
}

import { ref, computed, toRef } from 'vue'
    import { useRoute } from 'vue-router'

    import { strCompare } from '@common/Common'
    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    import type { CriteriaPanelistsManagerViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaPanelistsManager'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriteriaPanelistsManager',
  props: {
    viewModel: {}
  },
  emits: ["include-panelist"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')
    const route = useRoute()

    // ---------------- local state ----------------

    const tag = ref<string | null>(null)
    const searchPhrase = ref<string | null>(null)

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const workspaceId = computed(() => vm.value.workspaceId)
    const projectId = computed(() => vm.value.projectId)

    const initialized = computed(() => vm.value.data != null)

    const projectUsers = computed(() => vm.value.data?.ProjectUsers ?? [])
    const tags = computed(() => vm.value.data?.ProjectUsersTags ?? [])

    const url_PeoplePage = computed(() =>
        dynamicUiRoutes.ProjectUsers_PeoplePage(
            route,
            workspaceId.value,
            projectId.value
        )
    )

    const projectUsersView = computed(() =>
    {
        let view = projectUsers.value.filter(pu => pu.IsArchived === false)

        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            view = view.filter(pu =>
                (`${pu.Name} ${pu.Email}`).toLowerCase().includes(phrase)
            )
        }

        if (tag.value)
        {
            view = view.filter(pu => pu.Tags.includes(tag.value))
        }

        return view.sort((a, b) =>
            strCompare(a.Name.toLowerCase(), b.Name.toLowerCase())
        )
    })

    // ---------------- actions ----------------

    function handleIncludePanelist(puId: number)
    {
        emit('include-panelist', puId)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Add panelists", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (projectUsers.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, [
                              _cache[5] || (_cache[5] = _createTextVNode(" You currently have no Respondents set-up in the software. Please go to the ", -1 /* CACHED */)),
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("People section", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, url_PeoplePage.value]
                              ]),
                              _cache[6] || (_cache[6] = _createTextVNode(" to upload names & emails. ", -1 /* CACHED */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (projectUsers.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("nav", _hoisted_12, [
                              _createElementVNode("form", _hoisted_13, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control form-control-sm mr-sm-2",
                                  type: "search",
                                  placeholder: "Search",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, searchPhrase.value]
                                ])
                              ]),
                              _createElementVNode("form", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("button", _hoisted_16, [
                                    _createElementVNode("span", null, "Filter by: " + _toDisplayString(tag.value ?? "Show all"), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (tag.value = null))
                                    }, "Show all"),
                                    _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "dropdown-header" }, "By tag:", -1 /* CACHED */)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (t) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (tag.value = t)
                                      }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_18))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("table", _hoisted_19, [
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectUsersView.value, (pu) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: pu.ProjectUserId
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("p", _hoisted_20, [
                                        _createElementVNode("span", null, _toDisplayString(pu.Name), 1 /* TEXT */)
                                      ]),
                                      (pu.HasEmail)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(pu.Email), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      (!pu.HasEmail)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_22, "Email not provided"))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("td", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pu.Tags, (t) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          class: "badge badge-secondary mr-1",
                                          key: t
                                        }, _toDisplayString(t), 1 /* TEXT */))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _createElementVNode("td", _hoisted_23, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-outline-secondary",
                                        onClick: ($event: any) => (handleIncludePanelist(pu.ProjectUserId)),
                                        disabled: pu.Included
                                      }, _toDisplayString(pu.Included ? "Added" : "Add"), 9 /* TEXT, PROPS */, _hoisted_24)
                                    ])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_26, [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("Add people", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, url_PeoplePage.value]
                ]),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})